import React from 'react';
import { View } from 'react-native';

import { Icon, IconName } from '@components/Icon';
import { StyleObj, Theme, makeStyles, useTheme } from '@providers/Theme';

type Preset = 'warning' | 'error';
type PresetDef = (theme: Theme) => {
  light: string;
  medium: string;
  main: string;
};

const presets: Record<Preset, PresetDef> = {
  error: (theme) => ({
    light: theme.palette.primary[50]!,
    medium: theme.palette.primary[100]!,
    main: theme.palette.primary[600]!,
  }),
  warning: (theme) => ({
    light: theme.palette.warning[100]!,
    medium: theme.palette.warning[200]!,
    main: theme.palette.warning[400]!,
  }),
};

export type CircledIconProps = {
  preset: Preset;
  icon: IconName;
  style?: StyleObj;
};

const useStyles = makeStyles<{ backgroundColor: string; borderColor: string }>({
  root: (props) => ({
    width: 50,
    height: 50,
    backgroundColor: props.backgroundColor,
    borderColor: props.borderColor,
    borderWidth: 8,
    borderRadius: 28,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }),
});

export const CircledIcon: React.FC<CircledIconProps> = ({
  icon,
  preset,
  style,
}) => {
  const presetDef = presets[preset];
  const theme = useTheme();
  const { light, medium, main } = presetDef(theme);
  const styles = useStyles({ backgroundColor: medium, borderColor: light });

  return (
    <View style={[styles.root, style]}>
      <Icon name={icon} color={main} />
    </View>
  );
};
